// left side is vertical, and bottom side is horizontal  

// defines position of the verticesdakafwerking =
function positionBuffer (totaleBreedte, plankHoogte, dikte, degrees, ox, oy, oyl, degreesOther) {
  const radians = degrees * (Math.PI/180);
  const r1 = (90 - degrees) * (Math.PI/180);

  const x = totaleBreedte + ox
  const z = dikte / 2
  const h = (totaleBreedte+ox)*Math.tan(radians) 
  const i = plankHoogte/(Math.sin(r1)) 
  // const j = plankHoogte*Math.sin(radians)
  // const k = Math.sqrt((plankHoogte**2)-(j**2))
  const l = (i-oyl)/Math.tan(radians)

  const degreeDiff = 90 - degrees - degreesOther

  const schuineZijde = plankHoogte / Math.cos(degreeDiff * (Math.PI/180))

  const mx = Math.cos(degrees * (Math.PI/180)) * schuineZijde
  const my = Math.sin(degrees * (Math.PI/180)) * schuineZijde

  const nx = mx - (schuineZijde * Math.cos(degreesOther * (Math.PI/180)))
  const ny = my + (schuineZijde * Math.sin(degreesOther * (Math.PI/180)))

  const mx2 = Math.cos(degreesOther * (Math.PI/180)) * schuineZijde
  const my2 = Math.sin(degreesOther * (Math.PI/180)) * schuineZijde


  return [
    //front
    -mx, -my, -z, 
    -x, -h-oyl, -z,
    -x, -h, -z, 

    -mx, -my, -z, 
    -x+l, -h-oyl, -z,
    -x, -h-oyl, -z,
    
    -mx, -my, -z, 
    -nx, -ny, -z,
    -x+l, -h-oyl, -z,


    //back
    0, 0, z, 
    -x, -h, z,
    -x, -h-oyl, z,

    0, 0, z, 
    -x, -h-oyl, z,
    -x+l, -h-oyl, z,
    
    
    0, 0, z, 
    -x+l, -h-oyl, z,
    mx2, -my2, z,


    //top
    0, 0, -z,
    -x, -h, -z,
    0, 0, z,

    -x, -h, -z,
    -x, -h, z,
    0, 0, z,


    //right
    -x, -h, -z,
    -x, -h-oyl, -z,
    -x, -h, z,

    -x, -h-oyl, -z,
    -x, -h-oyl, z,
    -x, -h, z,


    //bottom
    -nx, -ny, -z,
    -x+l, -h-oyl, z,
    -x+l, -h-oyl, -z,
    
    -nx, -ny, -z,
    -nx, -ny, z,
    -x+l, -h-oyl, z,


    //bottom2
    -x, -h-oyl, -z,
    -x+l, -h-oyl, -z,
    -x, -h-oyl, z,
    
    -x+l, -h-oyl, -z,
    -x+l, -h-oyl, z,
    -x, -h-oyl, z,
    
    
    //left
    0, 0, -z,
    0, -i, z,
    0, -i, -z,

    0, 0, -z,
    0, 0, z,
    0, -i, z,
  ]
}

// defines position of the textures
function uvBuffer (totaleBreedte, plankHoogte, dikte, degrees, ox, oy, oyl, degreesOther, maxTextureWith, maxTextureHeight) { 
  const positions = positionBuffer(totaleBreedte, plankHoogte, dikte, degrees, ox, oy, oyl, degreesOther)
  const uvs = []
  const MAX_W = maxTextureWith || 2330
  const MAX_H = maxTextureHeight || 145

  const degToRad = deg => deg * Math.PI / 180;

  // face vertex ranges (each triangle = 3 vertices)
  const faceDefs = [
    { name: "front",   start: 0,  end: 8,  rot:  -degrees, axes: ["x", "y"] },
    { name: "front2",  start: 9,  end: 17, rot:  -degrees, axes: ["x", "y"] },
    { name: "top",     start: 18, end: 23, rot:  0, axes: ["x", "z"] },
    { name: "right",   start: 24, end: 29, rot:  0, axes: ["y", "z"] },
    { name: "bottom",  start: 30, end: 35, rot:  0, axes: ["x", "z"] },
    { name: "bottom2", start: 36, end: 41, rot:  0, axes: ["x", "z"] },
    { name: "left",    start: 42, end: 47, rot:  0, axes: ["y", "z"] },
  ];

  let vertexIndex = 0;          // counts vertices, not floats
  for (let i = 0; i < positions.length; i += 3, vertexIndex++) {
    let x = positions[i];
    let y = positions[i + 1];
    let z = positions[i + 2];

    // figure out which face this vertex belongs to
    let face = faceDefs.find(f => vertexIndex >= f.start && vertexIndex <= f.end);
    if (!face) face = { rot: 0, axes: ["x", "y"] }; // fallback

    const angle = degToRad(face.rot);
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);

    // get UV axes
    let a1, a2;
    switch (face.axes[0]) {
      case "x": a1 = -x; break;
      case "y": a1 = -y; break;
      case "z": a1 = -z; break;
    }
    switch (face.axes[1]) {
      case "x": a2 = -x; break;
      case "y": a2 = -y; break;
      case "z": a2 = -z; break;
    }

    // rotate in 2D (in the local plane)
    const u_ = a1 * cos - a2 * sin;
    const v_ = a1 * sin + a2 * cos;

    // scale to UV space
    const u = u_ / MAX_W;
    const v = v_ / MAX_H;

    uvs.push(u, v);
  }

  return uvs
}

// defines orientation of the faces (texture inside or outside)
function normalBuffer () {
  //return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
  //return [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,]
  //return [0,0,1]
  return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
}

// group the vertices belonging to each of the 6 sides, allows for 6 different textures one for each side.
function groupBuffer () {
  return [
    {
      start: 0,
      count: 6,
      materialIndex: 0
    },
    {
      start: 6,
      count: 6,
      materialIndex: 1
    },
    {
      start: 12,
      count: 6,
      materialIndex: 2
    },
    {
      start: 18,
      count: 6,
      materialIndex: 3
    },
    {
      start: 24,
      count: 6,
      materialIndex: 4
    },
    {
      start: 30,
      count: 6,
      materialIndex: 5
    }
  ]
}

export { positionBuffer, uvBuffer, normalBuffer, groupBuffer }